<template>
  <Dialog
    v-if="visible"
    :visible="visible"
    @update:visible="updateVisible"
    modal
    position="center"
    class="h-auto min-w-82 max-w-234 rounded-sm! overflow-hidden dark:bg-surface-primary"
    :class="modalClass"
    :closable="closable"
  >
    <template #closebutton>
      <div
        v-if="closable"
        class="absolute top-1 right-5 w-8 h-8 flex items-center justify-center rounded-full cursor-pointer hover:bg-gray-200 dark:hover:bg-dark-border"
        @click="updateVisible(false)"
      >
        <font-awesome-icon
          icon="fa-solid fa-xmark"
          class="text-text-primary text-[16px]"
        />
      </div>
    </template>
    <!-- Slot para el header -->
    <template #header>
      <slot name="header"></slot>
    </template>

    <!-- Slot para la descripción -->
    <div class="overflow-hidden">
      <slot name="description"></slot>
    </div>

    <!-- Slot para datos dinámicos -->
    <div class="overflow-hidden">
      <slot name="content"></slot>
    </div>

    <!-- Slot para los botones -->
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
const props = defineProps({
  visible: Boolean,
  modalClass: String,
  closable: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const emit = defineEmits(["update:visible"]);

const updateVisible = (value: boolean) => {
  console.log("estado del modal", value);
  emit("update:visible", value);
};
</script>
